import React, { useContext } from 'react';
import RecorderDrawerContext from '../../Context';
import cx from 'classnames';
import {
  AnimatedDiv,
  HideAnimation,
  ShowAnimation,
} from '@vimily/bonjoro-ui-components-v2/AnimatedDiv';
import { MAX_MESSAGE_TEMPLATE_TEXT_LENGTH } from '~/Share/constants';
import { TextArea } from '@vimily/bonjoro-ui-components-v2/TextArea';

const maxLength = MAX_MESSAGE_TEMPLATE_TEXT_LENGTH;

export function MessagePanel() {
  const {
    hasValidVideo,
    message = '',
    setMessage,
  } = useContext(RecorderDrawerContext);

  const textLimitReached = message.length < maxLength;
  const count = maxLength - message.length;

  return (
    <AnimatedDiv
      show={hasValidVideo}
      className='flex flex-col gap-y-4 w-full relative'
      showAnimation={ShowAnimation.SlideInUp150}
      hideAnimation={HideAnimation.SlideOutDown150}
    >
      <div className='flex flex-row justify-between'>
        <div className='flex flex-row gap-x-4 items-center'>
          <i className='icon icon-message-bubble !v2-bg-neutral-900' />
          <span className='text-[21px] font-bold'>Message</span>
        </div>
        {/* 
          TODO: Create function to save previously used template for user included the edited message
          https://bonjoro.atlassian.net/browse/PLG-500
        */}
      </div>
      <TextArea
        value={message}
        maxLength={maxLength}
        rows={5}
        autoComplete='off'
        autoCorrect='off'
        onChange={(e) => setMessage((e.target as HTMLTextAreaElement).value)}
        className={cx([
          'w-full overflow-y-auto py-2 px-4 resize-none text-base !rounded-none',
          'hover:!v2-border-neutral-300 focus:!v2-border-neutral-300',
          '!h-[180px]',
        ])}
      />
      <span
        className={cx('pointer-events-none bottom-3 right-5 text-xs absolute', {
          'v2-text-neutral-500': textLimitReached,
          'v2-text-red-900': !textLimitReached,
        })}
      >
        {count}/{maxLength}
      </span>
    </AnimatedDiv>
  );
}
